export interface OverrideEntity {
    EDIT_TYPE: string;
    EDIT_COMMENTS: string;
    CHILD_ID: string;
    STUB: string;
    TAX_YEAR: string;
    SCENARIO: string;
    START_DATE: string;
    END_DATE: string;
    LE_SHORT_NAME: string;
    GECC_ENTITY_ID: string;
    TAX_TYPE: string;
    HO_LEIDS: string;
    HO_GECC_ENTITY_ID: string;
    HO_TAX_TYPE: string;
    HO_COUNTRY_INCORPORATED: string;
    CLASSIFICATION_DESC: string;
    CLASSIFICATION: string;
    ACQUISITION_DATE: string;
    DATE_INCORPORATED: string;
    DATE_SPAWNED_CONSUMED: string;
    DATE_DISSOLVED: string;
    DATE_LIQUIDATED: string;
    DATE_SOLD: string;
    TAX_CONSOLIDATION_GRP: string;
    TAX_CONSOLIDATION_GRP_DESC: string;
    COUNTRY_INCORPORATED: string;
    RETURN_PREPARED_BY: string;
    GOLD_START_DATE: string;
    GOLD_END_DATE: string;
    DCS_ENTITY: string;
    FIR_ENTITY: string;
    SUB_CONSOL: string;
    TECH_TERM: string;
    SINGLE_OWNER_PSHIP: string;
    PROCESS_NOTES: string;
    UPDATED: string;
    DATA_HASH: string;
    FILING_REQUIREMENT: string;
    ROLL_FORWARD: string;
    US_HO_LEID: string;
    US_HO_REPORTING_PERIOD: string;
    ENTITY_TYPE: string;
    
    // UI-specific validation fields
    CHILD_ID_NOT_VALID?: boolean;
    STUB_NOT_VALID?: boolean;
    START_DATE_NOT_VALID?: boolean;
    END_DATE_NOT_VALID?: boolean;
    TAX_TYPE_NOT_VALID?: boolean;
    CLASSIFICATION_NOT_VALID?: boolean;
    DATE_INCORPORATED_NOT_VALID?: boolean;
    DATE_DISSOLVED_NOT_VALID?: boolean;
    TAX_CONSOLIDATION_GRP_NOT_VALID?: boolean;
    COUNTRY_INCORPORATED_NOT_VALID?: boolean;
    RETURN_PREPARED_BY_NOT_VALID?: boolean;
    ENTITY_TYPE_NOT_VALID?: boolean;
    FILING_REQUIREMENT_NOT_VALID?: boolean;
    ROLL_FORWARD_NOT_VALID?: boolean;
    EDIT_COMMENTS_NOT_VALID?: boolean;
    
    // UI-specific date picker fields
    START_DATE_CLICK?: boolean;
    END_DATE_CLICK?: boolean;
    ACQUISITION_DATE_CLICK?: boolean;
    DATE_INCORPORATED_CLICK?: boolean;
    DATE_SPAWNED_CONSUMED_CLICK?: boolean;
    DATE_DISSOLVED_CLICK?: boolean;
    DATE_LIQUIDATED_CLICK?: boolean;
    DATE_SOLD_CLICK?: boolean;
    GOLD_START_DATE_CLICK?: boolean;
    GOLD_END_DATE_CLICK?: boolean;
  }
  
  export interface LegalEntity {
    CHILD_ID: string;
    LE_SHORT_NAME: string;
    STUB: string;
    [key: string]: any;
  }
  
  export interface Classification {
    CLASSIFICATION: string;
    CLASSIFICATION_DESC: string;
  }
  
  export interface TaxConsolidationGroup {
    TAX_CONSOLIDATION_GRP: string;
    TAX_CONSOLIDATION_GRP_DESC: string;
  }
  
  export interface DefaultStub {
    label: string;
    value: number;
  }
  
  export interface ComponentMode {
    CREATE: 'create';
    UPDATE: 'update';
  }
  
  export interface ApiResponse<T = any> {
    callSuccess: string;
    errorMessage: string;
    jsonObject: T;
  }
  
  export interface SaveParams {
    clob_data: string;
    clob_settings: string;
    tax_year: string;
    scenario: string;
    scenarioCode?: string;
    is_issue_key_enabled: string;
    [key: string]: any;
  }
  
  export const COMPONENT_MODE = {
    CREATE: 'create' as const,
    UPDATE: 'update' as const
  };
  
  export const DEFAULT_STUBS: DefaultStub[] = [
    { label: '1', value: 1 },
    { label: '2', value: 2 },
    { label: '3', value: 3 },
    { label: '4', value: 4 },
    { label: '5', value: 5 },
    { label: '6', value: 6 }
  ];
  
  export const RETURN_PREPARED_BY_OPTIONS = [
    { label: 'Corporate', value: 'Corporate' },
    { label: 'External', value: 'External' }
  ];
  
  export const ENTITY_TYPE_OPTIONS = [
    { label: 'Domestic', value: 'D' },
    { label: 'Foreign', value: 'F' }
  ];
  
  export const YES_NO_OPTIONS = [
    { label: 'Yes', value: 'Y' },
    { label: 'No', value: 'N' }
  ];